import React from 'react'
import PropTypes from 'prop-types'
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import { createTuinaProject, updateTuinaProject } from '@/service/tuina'
import ProjectForm from './ProjectForm'

const fromValue = (fields) => {
  const { cover, ...rest } = fields
  const coverList = Array.isArray(cover) ? cover : []
  const coverItem = coverList[0]
  const originFileObj = coverItem && coverItem.originFileObj
  if (!originFileObj) return rest
  return {
    ...rest,
    cover: originFileObj
  }
}

class ProjectModal extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    actType: PropTypes.oneOf(['create', 'edit']),
    record: PropTypes.object,
    onSuccess: PropTypes.func
  }

  static defaultProps = {
    actType: 'create'
  }

  handleOk = async (form) => {
    const { actType, record, onSuccess } = this.props
    const fields = await form.current.validateFields()
    const formatFields = fromValue(fields)

    switch (actType) {
      case 'create':
        await createTuinaProject(formatFields)
        message.success('已新增')
        break
      case 'edit':
        await updateTuinaProject(record.id, formatFields)
        message.success('已保存')
        break
      default:
        return
    }
    onSuccess()
  }

  render () {
    const { children, actType, record } = this.props
    const projectName = (record && record.name) || ''
    const title = actType === 'edit' ? `编辑 ${projectName} 项目` : '新增项目'
    return (
      <WrappedModal
        children={children}
        title={title}
        okText={actType === 'edit' ? '保存' : '新增'}
        okButtonProps={{ size: 'large' }}
        cancelButtonProps={{ size: 'large' }}
        width={560}
        baseComponent={<ProjectForm />}
        baseProps={{ actType, record }}
        onOk={this.handleOk}
      />
    )
  }
}

export default ProjectModal
